import { render } from "./ThreeDots.vue?vue&type=template&id=2d43ddea"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ThreeDots.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d43ddea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d43ddea', __exports__)) {
    api.reload('2d43ddea', __exports__)
  }
  
  module.hot.accept("./ThreeDots.vue?vue&type=template&id=2d43ddea", () => {
    api.rerender('2d43ddea', render)
  })

}


export default __exports__